var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookingEvent(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    width: "24px",
    height: "24px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BB1B22B4-E7A3-404C-8133-5D9336C41ECB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-184.000000, -551.000000)",
    fill: "#FA0056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bullet_event_room",
    transform: "translate(184.000000, 551.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,30 C0,13.4314575 13.4278145,0 30,0 L30,0 C46.5685425,0 60,13.4278145 60,30 L60,30 C60,46.5685425 46.5721855,60 30,60 L30,60 C13.4314575,60 0,46.5721855 0,30 L0,30 Z",
    id: "Background",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-/-FAB-/-event-room",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "event_available-24px",
    transform: "translate(5.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    opacity: 0.4,
    points: "4.16666667 8.16666667 29.8333333 8.16666667 29.8333333 11.8333333 4.16666667 11.8333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8333333,4.5 L28,4.5 L28,0.833333333 L24.3333333,0.833333333 L24.3333333,4.5 L9.66666667,4.5 L9.66666667,0.833333333 L6,0.833333333 L6,4.5 L4.16666667,4.5 C2.15,4.5 0.5,6.15 0.5,8.16666667 L0.5,33.8333333 C0.5,35.85 2.15,37.5 4.16666667,37.5 L29.8333333,37.5 C31.85,37.5 33.5,35.85 33.5,33.8333333 L33.5,8.16666667 C33.5,6.15 31.85,4.5 29.8333333,4.5 Z M29.8333333,33.8333333 L4.16666667,33.8333333 L4.16666667,15.5 L29.8333333,15.5 L29.8333333,33.8333333 Z M29.8333333,11.8333333 L4.16666667,11.8333333 L4.16666667,8.16666667 L29.8333333,8.16666667 L29.8333333,11.8333333 Z M25.2316667,20.1383333 L23.2883333,18.195 L14.36,27.1233333 L10.4916667,23.255 L8.54833333,25.1983333 L14.36,31.01 L25.2316667,20.1383333 Z",
    id: "Shape"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingEvent);
export default __webpack_public_path__ + "static/media/booking-event.292f6adc6addb8d9793351b12881c966.svg";
export { ForwardRef as ReactComponent };